import React from 'react';
import styles from './TypingIndicator.module.css';

interface TypingIndicatorProps {
  className?: string;
}

export const TypingIndicator: React.FC<TypingIndicatorProps> = ({
  className,
}) => {
  return (
    <div className={`${styles.typingIndicator} ${className || ''}`}>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};

export default TypingIndicator;
